import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreSonarObjectsSearchSlice } from './get';

export const coreSonarObjectsSearchReducers = combineReducers({
	get: getCoreSonarObjectsSearchSlice.asyncReducers
});

export const coreSonarObjectsSearchWatchers = combineAllWatchers([ getCoreSonarObjectsSearchSlice.asyncWatchers ]);
